// 宛名の検証（Issue #46）。
//
// ★現行 ReceiptIssue.ts の validate() と同じ2つだけ。増やさない。
//     - 宛名が空
//     - 宛名が30文字を超える
//   どちらかに当たると発行ボタンが効かない（押しても何も起きない）のも現行どおり。
//
// ★文字数の数え方も現行どおり `String.length`（UTF-16 のコード単位）にしてある。
//   絵文字やサロゲートペアは2文字として数えるが、宛名にそれが入ることは想定されていないうえ、
//   数え方を変えると「いまは通る宛名が通らなくなる」側の変化が出る。合わせておくのが安全。

import { TEXT as T } from './text'

export const NAME_MAX = 30

/** 表示する検証エラーの一覧。空配列なら発行できる。 */
export function validateName(name: string): string[] {
  const errors: string[] = []
  // 現行は ng-model の値をそのまま見る（trim しない）。空白だけの宛名は通ってしまうが、挙動を変えない。
  if (!name) errors.push(T.validation.nameRequired)
  if (name.length > NAME_MAX) errors.push(T.validation.nameTooLong)
  return errors
}

export function canIssue(name: string): boolean {
  return validateName(name).length === 0
}
